// extracted by mini-css-extract-plugin
export var statItem = "_cq-1";
export var statsRow = "_cq-0";